import type { IconData } from '@stacksjs/iconify-core'

export const bing: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m10.129 8.596l1.735 4.328l2.77 1.29L19 16.247V11.7z\" opacity=\".7\"/><path fill=\"currentColor\" d=\"M14.634 14.214L9 17.457V3.4L5 2v17.76L9 22l10-5.753V11.7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bing
